import { SELECT_ACTOR } from '../../actions/game/targetActor.actions'

const initialState = ''

const targetActorReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case SELECT_ACTOR: {
            const { actor } = payload
            return actor
        }

        default: {
            return state
        }
    }
}

export default targetActorReducer
